<ng-template #statusTemplate let-packageData>
  <p-tag
    [value]="getStatusText(packageData)"
    [severity]="getStatusSeverity(packageData)"
    [rounded]="true">
  </p-tag>
</ng-template>

<div>
  <div class="flex items-center gap-3 mb-6">
    <div class="flex items-center justify-center w-10 h-10 rounded-lg bg-primary-100 dark:bg-primary-900/30">
      <i class="pi pi-shopping-bag text-primary-600 dark:text-primary-400"></i>
    </div>
    <h3 class="text-xl font-semibold text-gray-900 dark:text-gray-100">{{ 'profile.packages.title' | translate }}</h3>
  </div>

  <div *ngIf="packages?.length === 0" class="text-center py-12 bg-gray-50 dark:bg-gray-700 rounded-lg border-2 border-dashed border-gray-300 dark:border-gray-600">
    <i class="pi pi-inbox text-6xl text-gray-400 dark:text-gray-500 mb-4 block"></i>
    <h3 class="font-semibold text-xl text-red-500 mb-3">{{ 'profile.packages.noPackages' | translate }}</h3>
    <p class="text-gray-600 dark:text-gray-400 mb-4">
      {{ 'profile.packages.visitStore' | translate }}
    </p>
    <a routerLink="/dashboard/store">
      <p-button
        [label]="'profile.packages.storeLinkText' | translate"
        icon="pi pi-shopping-cart"
        styleClass="p-button-rounded">
      </p-button>
    </a>
  </div>

  <eko-generic-table
    *ngIf="packages?.length > 0"
    styleClass="p-datatable-gridlines"
    [columnRows]="columnRows"
    [dataProvider]="dataProvider"
    [tableConfig]="tableConfig">
  </eko-generic-table>
</div>
